import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
const DarkModeContext = createContext(undefined);
export const DarkModeProvider = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(() => {
        // Check localStorage first, then system preference
        const saved = localStorage.getItem('darkMode');
        if (saved !== null) {
            return JSON.parse(saved);
        }
        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    });
    useEffect(() => {
        // Save to localStorage
        localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
        // Apply to document
        if (isDarkMode) {
            document.documentElement.classList.add('dark');
        }
        else {
            document.documentElement.classList.remove('dark');
        }
    }, [isDarkMode]);
    const toggleDarkMode = () => {
        setIsDarkMode(prev => !prev);
    };
    return (_jsx(DarkModeContext.Provider, { value: { isDarkMode, toggleDarkMode }, children: children }));
};
export const useDarkMode = () => {
    const context = useContext(DarkModeContext);
    if (context === undefined) {
        throw new Error('useDarkMode must be used within a DarkModeProvider');
    }
    return context;
};
